<app-header></app-header>

<main class="main-content" id="main-content" role="main">
  <router-outlet />
</main>

<app-footer></app-footer>

